module.exports = __webpack_public_path__ + "img/elementheights_jasa.ff432ce1.png";